module.exports = __webpack_public_path__ + "img/v9.f6603f5d.png";